/*
 * size-cards.js — DROOL Size Cards (v5, native picker rendering).
 * The cards ARE the variant picker's native size radios (server-rendered), so
 * selection / morph / add-to-cart are all native. This script only *decorates*:
 * dimensions, £-per-area, size-vs-price, badges, and the cm/inch toggle.
 * No relocation, no sync — nothing to revert on morph.
 */
(function(){
  'use strict';
  var IN2_CM2=6.4516, IN_CM=2.54;
  function r1(n){return Math.round(n*10)/10;}
  function pct(x){return Math.round(x*100)+'%';}
  function esc(t){return String(t).replace(/[<>&]/g,function(c){return{'<':'&lt;','>':'&gt;','&':'&amp;'}[c];});}

  function parseValue(str){
    var o={inch:null,cm:null,label:''}; if(!str) return o; var s=String(str);
    var m=s.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)\s*(?:"|”|''|in\b|inch)/i);
    if(!m) m=s.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/);
    if(m) o.inch={w:parseFloat(m[1]),h:parseFloat(m[2])};
    var cm=s.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)\s*cm/i);
    if(cm) o.cm={w:parseFloat(cm[1]),h:parseFloat(cm[2])};
    var p=s.match(/\(([^)]+)\)/); if(p){var t=p[1].trim(); if(/^[A-Z]?\d+[A-Z]?$/i.test(t)) o.label=t;}
    return o;
  }
  function moneyNum(t){if(!t) return NaN;return parseFloat(String(t).replace(/,/g,'').replace(/[^0-9.]/g,''));}
  function moneySym(t){if(!t)return'£';var l=String(t).match(/^[^\d-]+/);if(l&&l[0].trim())return l[0].trim();var tr=String(t).match(/[^\d.,\s]+$/);return tr?tr[0].trim():'£';}
  function dimsText(p,u){
    if(u==='cm'){if(p.cm)return p.cm.w+'×'+p.cm.h+'cm';if(p.inch)return r1(p.inch.w*IN_CM)+'×'+r1(p.inch.h*IN_CM)+'cm';return'';}
    if(p.inch)return p.inch.w+'×'+p.inch.h+'"';if(p.cm)return r1(p.cm.w/IN_CM)+'×'+r1(p.cm.h/IN_CM)+'"';return'';
  }
  function sqText(price,areaIn,u,sym){if(areaIn<=0)return'';if(u==='cm'){return sym+(price/(areaIn*IN2_CM2)).toFixed(3)+'/cm²';}return sym+(price/areaIn).toFixed(2)+'/in²';}

  // Region → canonical unit. Some regions ship inch-true prints (a US 20x28" is a
  // true 20×28in = 50.8×71.1cm), others ship metric-true (50×70cm = 19.7×27.6").
  // Returns 'inch'/'cm' from the visitor's country, or null when unknown.
  function regionUnit(fs){
    var inchRegions=(fs.getAttribute('data-inch-regions')||'').toUpperCase().split(/[^A-Z]+/).filter(Boolean);
    var country=((window.Shopify&&window.Shopify.country)||'').toUpperCase();
    if(!country) return null;                                  // unknown → fall back to editor default
    return inchRegions.indexOf(country)!==-1 ? 'inch' : 'cm';
  }
  // Populate both units, deriving the non-canonical one from the canonical (true)
  // measurement so dims/area reflect the product actually shipped to that region.
  // canonical null → keep both labelled values as-is (legacy behaviour).
  function reconcile(p,canonical){
    if(p.inch&&p.cm){
      if(canonical==='inch') p.cm={w:r1(p.inch.w*IN_CM),h:r1(p.inch.h*IN_CM)};
      else if(canonical==='cm') p.inch={w:r1(p.cm.w/IN_CM),h:r1(p.cm.h/IN_CM)};
    }else if(p.inch&&!p.cm){ p.cm={w:r1(p.inch.w*IN_CM),h:r1(p.inch.h*IN_CM)}; }
    else if(p.cm&&!p.inch){ p.inch={w:r1(p.cm.w/IN_CM),h:r1(p.cm.h/IN_CM)}; }
    return p;
  }

  // Make the size cards exactly the frame swatch buttons' width + gap, measured
  // live (so it tracks every breakpoint). Scoped to this picker. No-op if the
  // setting is off or no frame buttons are present (e.g. unframeable products).
  function syncFrameWidth(fs){
    if(fs.getAttribute('data-match-frame-width')==='false') return;
    var scope=fs.closest('variant-picker')||fs.closest('.drool-picker-cards')||document;
    var sel='.mrk-frame-switcher .variant-option__button-label, .mrk-frame-switcher label.mrk-child-frame-item';
    var btns=scope.querySelectorAll(sel);
    if(!btns.length) btns=document.querySelectorAll(sel);
    if(!btns.length) return;
    var w=btns[0].getBoundingClientRect().width;
    if(w>20) fs.style.setProperty('--mrk-sc-card-w', Math.round(w)+'px');
    var br=getComputedStyle(btns[0]).borderTopLeftRadius;          // match the frame button corner radius exactly
    if(br && br!=='0px') fs.style.setProperty('--mrk-sc-radius', br);
    if(btns.length>1){
      var g=btns[1].getBoundingClientRect().left-btns[0].getBoundingClientRect().right;
      if(g>0&&g<48) fs.style.setProperty('--mrk-sc-gap', Math.round(g)+'px');
    }
  }

  function decorate(fs){
    syncFrameWidth(fs);
    var canonical=regionUnit(fs);
    var u=window.__mrkScUnit||canonical||fs.getAttribute('data-default-unit')||'inch'; if(u!=='cm'&&u!=='inch')u='inch';
    var showCmp=fs.getAttribute('data-show-compare')!=='false';
    var base=fs.getAttribute('data-compare-base')||'relative';
    var priceFmt=fs.getAttribute('data-price-format')||'gbp';
    var sizeFmt=fs.getAttribute('data-size-format')||'mult';
    var sizeWord=fs.getAttribute('data-size-word')||'times';            // 'times' (×the size) | 'bigger' (×bigger/smaller)
    var showPriceDelta=fs.getAttribute('data-show-price-delta')!=='false'; // include "+£X" in the compare line?
    var showSq=fs.getAttribute('data-show-persq')!=='false';
    var sqByPrice=fs.getAttribute('data-persq-by-price')!=='false';
    var showPop=fs.getAttribute('data-show-popular')!=='false';
    var popText=fs.getAttribute('data-popular-text')||'Most popular';
    var popOn=(fs.getAttribute('data-popular-on')||'').toLowerCase();
    var showBest=fs.getAttribute('data-show-best')!=='false';
    var bestText=fs.getAttribute('data-best-text')||'Best value';

    var cards=Array.prototype.slice.call(fs.querySelectorAll('.mrk-sc__cardwrap'));
    var sym='£',minPpa=Infinity,selIdx=-1,smallestIdx=0,minArea=Infinity;
    cards.forEach(function(w,i){
      var radio=w.querySelector('input[type=radio]');
      var priceEl=w.querySelector('.mrk-sc__price');
      var price=moneyNum(priceEl&&priceEl.getAttribute('data-money'))/100;
      if(isNaN(price)) price=moneyNum(priceEl&&priceEl.getAttribute('data-base'));
      var parsed=reconcile(parseValue(w.getAttribute('data-value')),canonical);
      var areaIn=parsed.inch?parsed.inch.w*parsed.inch.h:0;
      sym=moneySym(priceEl&&priceEl.getAttribute('data-base'))||sym;
      w._sc={radio:radio,price:price,parsed:parsed,areaIn:areaIn,checked:radio&&radio.checked,ppa:areaIn>0?price/areaIn:Infinity};
      if(w._sc.ppa<minPpa)minPpa=w._sc.ppa;
      if(areaIn>0&&areaIn<minArea){minArea=areaIn;smallestIdx=i;}
      if(w._sc.checked)selIdx=i;
    });
    if(selIdx<0)selIdx=0;

    // No two cards on a product should share a size name. When two sizes fall in
    // the same tier (e.g. both "Large"), the larger takes the transitional
    // "Large/XL" format. Re-runs from the server-rendered base names each decorate,
    // so it's idempotent.
    var TIERS=['XS','Small','Medium','Large','XL','XXL','3XL','4XL'];
    (function(){
      var byArea=cards.slice().sort(function(a,b){return a._sc.areaIn-b._sc.areaIn;});
      var seen={};
      byArea.forEach(function(w){
        var el=w.querySelector('.mrk-sc__name'); if(!el) return;
        var nm=(el.textContent||'').trim();
        if(seen[nm]){
          var idx=TIERS.indexOf(nm);
          if(idx>=0&&idx<TIERS.length-1) el.textContent=nm+'/'+TIERS[idx+1];
        } else { seen[nm]=true; }
      });
    })();

    function sizeDelta(c,r){
      var ratio=c.areaIn/r.areaIn;
      if(!isFinite(ratio)||ratio<=0)return '';
      if(sizeWord==='bigger'){
        if(ratio>=0.995&&ratio<=1.005)return '';
        return r1(ratio)+(ratio<1?'× smaller':'× bigger');
      }
      if(sizeFmt==='mult')return r1(ratio)+'× the size';
      var d=ratio-1;return (d>=0?'+':'−')+pct(Math.abs(d))+' size';
    }
    function priceDelta(c,r){var d=c.price-r.price;if(priceFmt==='gbp'){return (d>=0?'+':'−')+sym+Math.abs(d).toFixed(Math.abs(d)%1?2:0);}var rr=c.price/r.price-1;return (rr>=0?'+':'−')+pct(Math.abs(rr));}
    function cmpLine(c,r){var parts=[];var sd=sizeDelta(c,r);if(sd)parts.push(sd);if(showPriceDelta)parts.push(priceDelta(c,r));return parts.join(' · ');}

    var popAssigned=false; // popular badge may appear on at most ONE card per product
    cards.forEach(function(w,i){
      var info=w._sc,parsed=info.parsed;
      var dimsEl=w.querySelector('.mrk-sc__dims'),cmpEl=w.querySelector('.mrk-sc__cmp'),sqEl=w.querySelector('.mrk-sc__sq'),priceEl=w.querySelector('.mrk-sc__price'),card=w.querySelector('.mrk-sc__card');

      var dText=dimsText(parsed,u);
      if(dimsEl){
        // Keep the dimensions on one line; only the "(A2)" label may wrap to line 2.
        // Dimension on its own row; the "(A2)" label always gets its own row below
        // (blank when there's no label) so every card's rows line up.
        dimsEl.innerHTML = dText
          ? '<span class="mrk-sc__dimval">'+esc(dText)+'</span><span class="mrk-sc__dimlabel">'+(parsed.label?'('+esc(parsed.label)+')':'')+'</span>'
          : '';
        dimsEl.hidden=!dText;
      }

      var cText='',neutral=false;
      var baseLabel=(sizeWord==='bigger')?'':'base size'; // 'bigger' mode: the anchor size just shows nothing
      if(showCmp){
        if(base==='relative'){
          if(i===selIdx){cText='Selected';neutral=true;}
          else{var ref=cards[selIdx]._sc;neutral=info.areaIn<=ref.areaIn;cText=cmpLine(info,ref);}
        }else if(base==='smallest'){
          if(i===smallestIdx){cText=baseLabel;neutral=true;}
          else{var rf=cards[smallestIdx]._sc;cText=cmpLine(info,rf);}
        }else{
          if(i===0){cText=baseLabel;neutral=true;}
          else{var rp=cards[i-1]._sc;cText=cmpLine(info,rp);}
        }
      }
      if(cmpEl){cmpEl.textContent=cText;cmpEl.hidden=false;cmpEl.classList.toggle('neutral',neutral);}

      var base$=priceEl?(priceEl.getAttribute('data-base')||priceEl.textContent):'';
      var sq=showSq?sqText(info.price,info.areaIn,u,sym):'';
      if(sqByPrice){
        if(priceEl) priceEl.innerHTML=esc(base$)+(sq?' · <span class="mrk-sc__sqinline">'+sq+'</span>':'');
        if(sqEl){sqEl.textContent='';sqEl.hidden=true;}
      }else{
        if(priceEl) priceEl.textContent=base$;
        if(sqEl){if(sq){sqEl.textContent=sq;sqEl.hidden=false;}else{sqEl.textContent='';sqEl.hidden=true;}}
      }

      var b=card&&card.querySelector('.badge'); while(b){b.remove();b=card.querySelector('.badge');}
      if(card){
        var nm=(w.querySelector('.mrk-sc__name')||{}).textContent||'';
        var matchesPop=showPop&&popOn&&(nm.toLowerCase()===popOn||String(w.getAttribute('data-value')).toLowerCase().indexOf(popOn)!==-1);
        var isPop=matchesPop&&!popAssigned;
        var isBest=showBest&&info.ppa===minPpa&&isFinite(minPpa);
        if(isPop&&isBest) isPop=false; // never stack badges — Best value wins
        if(isPop){popAssigned=true;var p=document.createElement('span');p.className='badge pop';p.textContent=popText;card.appendChild(p);}
        if(isBest){var v=document.createElement('span');v.className='badge best';v.textContent=bestText;card.appendChild(v);}
      }

      w.classList.toggle('is-selected',!!info.checked);
      w.classList.toggle('is-unavailable',w.getAttribute('data-available')==='false');
    });

    Array.prototype.forEach.call(fs.querySelectorAll('.mrk-sc__unit'),function(btn){var a=btn.getAttribute('data-unit')===u;btn.classList.toggle('is-active',a);btn.setAttribute('aria-pressed',a?'true':'false');});
    arrows(fs);
    // Center only when the SELECTED card actually changes (so the track isn't
    // animating under the user's finger on every re-render). Instant on first paint.
    if(fs.__lastCenteredIdx !== selIdx){
      var firstRun = fs.__lastCenteredIdx===undefined;
      fs.__lastCenteredIdx = selIdx;
      centerSelected(fs, !firstRun);
    }
  }

  function track(fs){return fs.querySelector('.mrk-sc__track');}
  function arrows(fs){
    if(fs.getAttribute('data-slider')==='false')return;
    var t=track(fs),p=fs.querySelector('.mrk-sc__arrow--prev'),n=fs.querySelector('.mrk-sc__arrow--next');if(!t||!p||!n)return;
    var ov=t.scrollWidth-t.clientWidth>2;p.hidden=!ov||t.scrollLeft<=1;n.hidden=!ov||t.scrollLeft>=t.scrollWidth-t.clientWidth-1;
    t.classList.toggle('mrk-sc__track--draggable',ov);
  }
  function scrollBy(fs,dir){
    var t=track(fs);if(!t)return;
    var cs=t.querySelectorAll('.mrk-sc__cardwrap');
    if(cs.length<1){t.scrollBy({left:dir*t.clientWidth*0.8,behavior:'smooth'});return;}
    // stride = one card + gap; scroll to a multiple of it so the track always lands
    // on a card edge (fixes the half-card gap left/right after tapping the arrows).
    var stride=cs.length>1?(cs[1].offsetLeft-cs[0].offsetLeft):cs[0].offsetWidth;
    if(stride<=0)stride=cs[0].offsetWidth||1;
    var cur=Math.round(t.scrollLeft/stride);
    var target=cur+dir*2; // move ~2 cards, boundary-aligned
    var left=Math.max(0,Math.min(target*stride,t.scrollWidth-t.clientWidth));
    t.scrollTo({left:left,behavior:'smooth'});
  }
  function centerSelected(fs, smooth){
    if(fs.getAttribute('data-slider')==='false') return;
    var t=track(fs); if(!t) return;
    if(t.scrollWidth-t.clientWidth<=2) return;
    var sel=fs.querySelector('.mrk-sc__cardwrap.is-selected'); if(!sel) return;
    requestAnimationFrame(function(){
      // Scroll ONLY the track horizontally — never scrollIntoView (that scrolls the page).
      var tr=t.getBoundingClientRect(), sr=sel.getBoundingClientRect();
      var delta=(sr.left+sr.width/2)-(tr.left+tr.width/2);
      if(Math.abs(delta)>1) t.scrollBy({left:delta,behavior:'auto'}); // instant: a smooth scroll here eats the next tap
    });
  }
  function selectCard(wrap){
    if(!wrap||wrap.classList.contains('is-unavailable'))return;
    var r=wrap.querySelector('input[type=radio]');
    if(r && !r.checked){ r.checked=true; r.dispatchEvent(new Event('change',{bubbles:true})); }
  }

  function bind(fs){
    if(fs.__bound)return;fs.__bound=true;
    fs.addEventListener('click',function(e){
      var unit=e.target.closest('.mrk-sc__unit');if(unit){var u=unit.getAttribute('data-unit');if(u==='cm'||u==='inch'){window.__mrkScUnit=u;decorateAll();}e.preventDefault();return;}
      var ar=e.target.closest('.mrk-sc__arrow');if(ar){scrollBy(fs,ar.classList.contains('mrk-sc__arrow--next')?1:-1);e.preventDefault();return;}
    });
    // Tap-to-select on a momentum-scrolling slider (iOS): when you flick the track
    // it keeps gliding, and a tap during that glide is normally consumed just to stop
    // the scroll. We (1) kill the momentum the instant the finger lands, so the slider
    // stops dead and the SAME tap counts, and (2) select on touchend/touchcancel.
    var t=track(fs);
    if(t){
      var ts=null;
      function stopMomentum(){
        if(t.scrollWidth-t.clientWidth<=2) return;
        var x=t.scrollLeft;
        // Toggling overflow forces iOS to halt in-flight momentum; restored immediately.
        t.style.overflowX='hidden'; void t.offsetWidth; t.style.overflowX='auto';
        t.scrollLeft=x;
      }
      function endTap(e){
        if(!ts)return; var s=ts; ts=null;
        if(s.moved || Date.now()-s.ti>700) return; // a scroll/drag, not a tap
        var ch=(e.changedTouches&&e.changedTouches[0])||null;
        var x=ch?ch.clientX:s.x, y=ch?ch.clientY:s.y;
        var el=document.elementFromPoint(x,y);
        var wrap=el&&el.closest&&el.closest('.mrk-sc__cardwrap');
        if(wrap){ if(e.cancelable) e.preventDefault(); selectCard(wrap); }
      }
      t.addEventListener('touchstart',function(e){
        if(e.touches.length!==1){ts=null;return;}
        var to=e.touches[0]; ts={x:to.clientX,y:to.clientY,ti:Date.now(),moved:false};
        stopMomentum();
      },{passive:true});
      t.addEventListener('touchmove',function(e){
        if(!ts)return; var to=e.touches[0];
        if(Math.abs(to.clientX-ts.x)>10||Math.abs(to.clientY-ts.y)>10) ts.moved=true;
      },{passive:true});
      t.addEventListener('touchend',endTap,{passive:false});
      t.addEventListener('touchcancel',endTap,{passive:false});
      t.addEventListener('scroll',function(){arrows(fs);},{passive:true});

      // Desktop: click-and-drag to slide the track (mouse only — touch is handled
      // above). A drag must NOT select a card, so we swallow the trailing click.
      var dn=false,dsx=0,dsl=0,dmoved=false;
      function dMove(e){var dx=e.clientX-dsx;if(Math.abs(dx)>3)dmoved=true;t.scrollLeft=dsl-dx;}
      function dUp(){
        dn=false;t.classList.remove('mrk-sc__track--grabbing');
        document.removeEventListener('mousemove',dMove);document.removeEventListener('mouseup',dUp);
        if(dmoved){
          var swallow=function(ev){ev.stopPropagation();ev.preventDefault();};
          t.addEventListener('click',swallow,true);
          setTimeout(function(){t.removeEventListener('click',swallow,true);},0);
        }
      }
      t.addEventListener('mousedown',function(e){
        if(e.button!==0||t.scrollWidth-t.clientWidth<=2)return;
        dn=true;dmoved=false;dsx=e.clientX;dsl=t.scrollLeft;
        t.classList.add('mrk-sc__track--grabbing');
        document.addEventListener('mousemove',dMove);document.addEventListener('mouseup',dUp);
      });
    }
    // native radio change (size selected) -> re-decorate (selection + relative compare)
    fs.addEventListener('change',function(){requestAnimationFrame(function(){decorate(fs);});});
  }

  function decorateAll(){Array.prototype.forEach.call(document.querySelectorAll('.mrk-size-cards'),decorate);}
  function runAll(){Array.prototype.forEach.call(document.querySelectorAll('.mrk-size-cards'),function(fs){bind(fs);decorate(fs);});}

  function boot(){
    runAll();
    if(!window.__mrkScGlobal){
      window.__mrkScGlobal=true;
      document.addEventListener('mrkVariantChanged',function(){requestAnimationFrame(runAll);});
      document.addEventListener('shopify:section:load',function(){requestAnimationFrame(runAll);});
      window.addEventListener('resize',function(){Array.prototype.forEach.call(document.querySelectorAll('.mrk-size-cards'),function(fs){syncFrameWidth(fs);arrows(fs);});});
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
